export default __webpack_public_path__ + "static/soehne-web-extrafett-kursiv-c33b6c4427ed0176752177675f02e1c3.eot";